<template>
  <FormItem class="slider-class-wrapper">
    <Slider
      v-bind="$attrs"
      @change="handleValueChange"
      :value="defaultValue"
      :min="minValue"
      :max="maxValue"
      :marks="marks"
      :range="range"
    />
    <span class="slider-label">{{ label }}</span>
  </FormItem>
</template>

<script>
import { FormModel, Slider, InputNumber } from "ant-design-vue";

export default {
  data() {
    return {
      defaultValue: [this.minValue, this.maxValue]
    };
  },
  components: {
    Slider,
    InputNumber,
    FormItem: FormModel.Item
  },
  computed: {
    attrValue() {
      return [];
    },
    marks() {
      return {
        [this.minValue]: `${this.markerTag}${this.minValue}`,
        [this.maxValue]: `${this.markerTag}${this.maxValue}`
      };
    }
  },
  methods: {
    formatter(value) {
      return `$${value}`;
    },
    handleValueChange(value) {
      this.defaultValue = value;
      this.$emit("change", value);
    }
  },
  props: {
    minValue: {
      type: Number,
      required: true
    },
    maxValue: {
      type: Number,
      required: true
    },
    step: {
      type: Number
    },
    range: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: ""
    },
    markerTag: {
      type: String,
      default: "$"
    }
  }
};
</script>

<style lang="sass">
.slider-class-wrapper
  .ant-form-item-control
    font-size: 12px
    position: relative
    .ant-form-item-children
      position: static
    .ant-slider-mark-text
      font-weight: 500
    .slider-label
      font-weight: 600
      font-size: 14px
      position: absolute
      top: 20px
      left: 50%
      transform: translate3d(-50%,0,0)
      white-space: nowrap
    .ant-slider-mark
      font-size: 12px
      position: relative
    .ant-slider
      .ant-slider-handle
        border: solid 2px #cc2f2a
      .ant-slider-track
        background-color: #cc2f2a
      .slider-label
        position: absolute
        top: 15px
        left: 100px
        white-space: nowrap
      .ant-slider-mark
        font-size: 12px
</style>
